export const updateUserAuth = (data) => ({type: 'USER_AUTH', data: data})
export const updateUserData = (data) => ({type: 'USER_DATA', data: data})
export const toggleMenuState = () => ({type: 'MENU_STATE'})
export const updateToken = (token) => ({type: 'TOKEN', token: token})
export const themeToggle = (theme) => ({type: 'THEME', theme: theme})
export const updateLines = (lines) => ({type: 'LINES', lines})
export const updateXRPBalance = (data) => ({type: 'XRP', data})
export const updateTokensInOffers = (tokens) => ({type: 'TOKENS', tokens})
export const updateUserCarats = (userCarats) => ({type: 'CARATS', userCarats})
export const updateUserPower = (userPower) => ({type: 'POWER', userPower})